import React, { FC } from 'react';
import ConfirmationModal from 'src/presentation/components/pages/shared/modals/ConfirmationModal';

type GoSaveNewExitNodeConfirmationModalProps = {
  title: string;
  onCancel: Function;
  onOk: Function;
};

const Description = (
  <>
    You wont be able to change the name of this node once you’ve
    <br /> set it. You will need to finish set up on the Channels page to
    <br /> connect this to an inbox.
  </>
);

const SaveSelectorFormConfirmationModal: FC<GoSaveNewExitNodeConfirmationModalProps> = ({ title, onCancel, onOk }) => (
  <ConfirmationModal title={title} onCancel={onCancel} onOk={onOk} content={Description} />
);

export default SaveSelectorFormConfirmationModal;
